import PropTypes from 'prop-types';
import React from 'react';

const TemperatureText = ({ min, max, intl, text }) => (
  <span>
    {intl.formatMessage(
      {
        id: 'temperature_literal',
        defaultMessage: text,
      },
      {
        min: String(min),
        max: String(max),
      }
    )}
  </span>
);

TemperatureText.propTypes = {
  min: PropTypes.any,
  max: PropTypes.any,
  intl: PropTypes.any,
  text: PropTypes.string,
};

export default TemperatureText;
